$(document).ready(function () {

  // Barre d'annonce
  // --------------------------------------------
  // Click sur le bouton de fermeture de la barre
  $('.close_announcement_bar').click(function (e) {
    e.preventDefault();
    $(this).remove();

    // Transition de fermeture
    $('#shopify-section-announcement-bar').slideUp(150, function () {
      $(this).remove();
    })

    // On stocke en session la demande de fermeture
    sessionStorage.setItem("closed_announcement", "true");
  });

  // redirection Home
  if ($(".diaporama").length) {
    $(document).on('click', '.diaporama .slick-slide', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  // redirection Home
  if ($(".grid__item.push_item").length) {
    $(document).on('click', '.grid__item.push_item', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  if ($(".double-image > div").length) {
    $(document).on('click', '.double-image > div', function () {
      var redirect = $(this).find("a").attr("href");
      if (redirect) {
        window.location.href = redirect;
      }
    });
  }

  if ($('#shopify-section-announcement-bar div').length > 1) {
    $(function () {
      $('#shopify-section-announcement-bar div:gt(0)').hide();
      setInterval(function () { $('#shopify-section-announcement-bar > :first-child').fadeOut(500).next('div').fadeIn(500).end().appendTo('#shopify-section-announcement-bar'); }, 4000);
    });
  }

  // On récupère la langue en cours
  var site_lng = $("html").attr("lang");

  // Positionne les megasmenu juste sous le header et sur la même gauche que le menu
  /*  $('.megamenu').css({ 'top': $('.header-wrapper').height(), "padding-left": $('.list-menu--inline').offset().left + 15 }); */

  // Fonction pour vérifier la présence de la classe 'menu-opening'
  function checkMenuOpening() {
    if ($('.menu-drawer-container').hasClass('menu-opening')) {
      // Ajouter la classe 'header_mobile' si 'menu-opening' est présent
      $('.header-wrapper').addClass('header_mobile');
    } else {
      // Retirer la classe 'header_mobile' si 'menu-opening' est absent
      $('.header-wrapper').removeClass('header_mobile');
    }
  }

  // MutationObserver pour surveiller les changements sur le div '.menu-drawer-container'
  const targetNode = document.querySelector('.menu-drawer-container');

  // Options pour l'observation : ici, on surveille les changements d'attributs (comme les classes)
  const config = { attributes: true, childList: false, subtree: false };

  // Callback exécutée quand une mutation est détectée
  const callback = function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Vérifier si la classe 'menu-opening' est présente et ajuster 'header_mobile'
        checkMenuOpening();
      }
    }
  };

  // Instancier l'observateur avec la fonction de callback
  const observer = new MutationObserver(callback);

  // Démarrer l'observation de l'élément
  if (targetNode) {
    observer.observe(targetNode, config);
  }

  // Facultatif : Surveiller le redimensionnement de la fenêtre et re-vérifier
  $(window).on('resize', function() {
    checkMenuOpening();
  });

  if ($(window).width() < 990) {

    $(document).on("click", ".header__icon--menu", function() {
      $('.header__icon--menu').toggleClass('open_icon');
      $('.header__icon--menu').toggleClass('close_icon');

      // si la class open_icon est présente alors on la retire et on ajoute la class close_icon
      if ($('.header__icon--menu').hasClass('open_icon')) {
        $('.menu-drawer__menu-item_1, .menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(0)');
      } else {
        // si la class close_icon est présente alors on la retire et on ajoute la class open_icon
        $('.header__icon--menu').removeClass('close_icon').addClass('open_icon');
      }
    });
  }

  // si je clique sur un details de menu de class class="menu-drawer__menu-item_1 alors je mets l'opactité de son enfant direct summary à 0
  $(document).on("click", "summary.menu-drawer__menu-item_1", function() {
    $('.menu-drawer__menu-item_1').css('transform', 'translate(-105%)');
  });

  $(document).on("click", "summary.menu-drawer__menu-item_2", function() {
    $('.menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(-105%)');
  });

  $(document).on("click", ".menu-drawer__close-button_1", function() {
    $('.menu-drawer__menu-item_1').css('transform', 'translate(0)');
  });

  $(document).on("click", ".menu-drawer__close-button_2", function() {
    $('.menu-drawer__menu-item_2, .menu-drawer__close-button_1, .childlink_title_1, .slider_images_mobile').css('transform', 'translate(0)');
  });

  $(document).on("click", ".header__icon--menu", function() {
    $('.menu-drawer__menu-item_1').css('transform', 'translate(0)');
  });

  $('.header__inline-menu .list-menu__item').click(function () {
    // Cache tous les autres menus d'abord
    $('.header__inline-menu .list-menu__item').not(this).each(function() {
      $(this).find(".megamenu").stop().fadeOut(100);
      $(this).find("a").removeClass("actif");
      $(this).find(".megamenu .level3 .js_grandchildren").removeClass("actif").hide();
      $(this).find(".megamenu .push_image img").attr('src', $(this).find(".megamenu .level2 a:first-of-type").data("push"));

      // Megamenu monde
      $(this).parent().find(".megamenu_monde").stop().fadeOut(50);
    });

    // Basculer l'affichage du menu actuel
    if ($(this).find(".megamenu").is(':visible')) {
      $(this).find(".megamenu").stop().fadeOut(100);
      $(this).find("a").removeClass("actif");
      $(this).find(".megamenu .level3 .js_grandchildren").removeClass("actif").hide();
      $(this).find(".megamenu .push_image img").attr('src', $(this).find(".megamenu .level2 a:first-of-type").data("push"));

      // Megamenu monde
      $(this).parent().find(".megamenu_monde").stop().fadeOut(50);
    } else {
      $(this).find(".megamenu").stop().fadeIn(100);
      $(this).find(".megamenu .level2 a:first-of-type").addClass("actif"); // ajoute l'actif au premier élément
      $(this).find(".megamenu .level3 .js_grandchildren:first-of-type").addClass("actif").fadeIn(0);
      $(this).find(".megamenu .push_image img").attr('src', $(this).find(".megamenu .level2 a:first-of-type").data("push"));

      // Megamenu monde
      $(this).parent().find(".megamenu_monde").stop().fadeIn(50);
    }
  });

    // Gestion du clic en dehors du menu
  $(document).click(function (e) {
    if (!$(e.target).closest('.header__inline-menu').length) {
      // Si le clic ne se fait pas dans le menu, fermer tous les menus
      $('.header__inline-menu .list-menu__item').each(function () {
        $(this).find(".megamenu").stop().fadeOut(100);
        $(this).find("a").removeClass("actif");
        $(this).find(".megamenu .level3 .js_grandchildren").removeClass("actif").hide();
        $(this).find(".megamenu .push_image img").attr('src', $(this).find(".megamenu .level2 a:first-of-type").data("push"));

        // Megamenu monde
        $(this).parent().find(".megamenu_monde").stop().fadeOut(50);
      });
    }
  });

  // Rollover sur les sous-catégories
  $('.level2 a').hover(
    function () {
      var target = $(this).data("target");
      var push = $(this).data("push");
      $(this).parent().parent().find(".js_grandchildren").removeClass("actif").hide();
      $(this).parent().find("a").removeClass("actif");
      $(this).parent().parent().find("[data-origin='" + target + "']").show().addClass("actif");
      $(this).addClass('actif');
      $(this).parent().parent().find(".push_image img").attr('src', push);
    }
  );

  // Lazy loading sur les pages Collections
  $('.js-load-more').on('click', function () {
    var $this = $(this), totalPages = parseInt($('[data-total-pages]').val()), currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        // On enrichi la liste des produits
        $('#product-grid').append($(responseHTML).find('#product-grid').html());
        // On met à jour le nombre de produits affichés
        $('.pagination_count').html($(responseHTML).find('.pagination_count').html());
      },
      complete: function () {
        if (currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        }
        if (currentPage == totalPages) {
          $this.hide();
        }
      }
    })
  });

  // Slick sur diaporama
  if ($('.diaporama').length) {
    var timing = $('.diaporama').data("timing") * 1000;
    $('.diaporama').slick({
      infinite: true,
      slidesToShow: 1,
      dots: true,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: timing,
      pauseOnHover: false,
      pauseOnDotsHover: false
    });
  }

  // SEO : ouverture et fermeture du "Voir plus"
  $(".read_more").click(function () {
    $(this).prev(".seo_content_rte").toggleClass("extend");
  });

  // Changement de layout sur les pages Collections
  $("#switch_layout .by1").click(function () {
    $("#switch_layout .by1").addClass("selected");
    $("#switch_layout .by2").removeClass("selected");
    $("#product-grid").addClass("grid--1-col");
    $("#product-grid").removeClass("grid--2-col");
  });

  $("#switch_layout .by2").click(function () {
    $("#switch_layout .by1").removeClass("selected");
    $("#switch_layout .by2").addClass("selected");
    $("#product-grid").removeClass("grid--1-col");
    $("#product-grid").addClass("grid--2-col");
  });

  $("#switch_layout .by3").click(function () {
    $("#switch_layout .by3").addClass("selected");
    $("#switch_layout .by4").removeClass("selected");
    $("#product-grid").addClass("grid--3-col-desktop");
    $("#product-grid").removeClass("grid--4-col-desktop");
  });

  $("#switch_layout .by4").click(function () {
    $("#switch_layout .by3").removeClass("selected");
    $("#switch_layout .by4").addClass("selected");
    $("#product-grid").removeClass("grid--3-col-desktop");
    $("#product-grid").addClass("grid--4-col-desktop");
  });

  // Bouton Quick_Shop sur les pages Collections
  $(document).on("click", ".quick_shop_button", function () {
    $("#shopify-section-quick_shop_drawer").remove();
    $("body").removeClass("noscroll");

    var lng_prefix = "";
    if (site_lng == "en") {
      lng_prefix = "/en";
    }

    $.ajax({
      url: lng_prefix + "/products/" + $(this).data("target") + "?section_id=quick_shop_drawer",
      type: "get",
      async: true,
      success: function (drawer) {
        $("body").append(drawer);
      }
    });

  });

  // Accordéon sur fiche produit
  $(".accordeon_elx_title").click(function () {
    $(".accordeon_elx_title").removeClass('open');
    if (!$(this).parent().find(".accordeon_elx_content").hasClass("opened")) {
      $(this).addClass("open");
      $(".accordeon_elx_content.opened").slideToggle(300, "linear", function () { $(this).removeClass("opened"); });
      $(this).parent().find(".accordeon_elx_content").slideToggle(300, "linear", function () { $(this).addClass("opened"); });
    }
    else {
      $(this).removeClass('open');
      $(".accordeon_elx_content.opened").slideToggle(300, "linear", function () {
        $(this).removeClass("opened");
      });
    }
  });

  // Sticky button sur fiche produit
  $(".sticky_button").click(function () {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".product__info-wrapper").offset().top
    }, 400);
  })

  // calcul de la hauteur du bloc infos produit sur la PDP
  if ($(".product_section").length) {
    var product_info_height = $(".product_section").offset().top;
    $(".product--stacked .product__info-container--sticky").css("height", "calc(100vh -" + product_info_height + "px)");
  }

  // Mise à jour de la date de livraison
  if ($(".estimated_delivery span").length) {
    adjust_delivery_time();
  }

  // FAQ
  $('.question').click(function () {
    $(this).find(".caret").toggleClass("actif");
    $(this).parent().find(".answer").slideToggle(200);
  })

  // Changement de langue
  $("#FooterLanguageForm select").change(function () {
    if ($(this).val() == "usd") {
      window.location.href = "https://us.eden-park.com/";
    }
    else if ($(this).val() == "cad_en") {
      window.location.href = "https://ca.eden-park.com/";
    }
    else if ($(this).val() == "cad_fr") {
      window.location.href = "https://ca.eden-park.com/fr/";
    }
    else if ($(this).val() == "fr") {
      window.location.href = "https://www.eden-park.com/";
    }
    else if ($(this).val() == "en") {
      window.location.href = "https://www.eden-park.com/en/";
    }
    else {
      $("#FooterLanguageForm").submit();
    }
  });


  // Ouverture popin réactivation compte
  $("[aria-controls=reactivation-modal]").click(function (e) {
    $("#reactivation-modal").css({ opacity: 1, display: "block", visibility: "unset" });
  });

  // Fermeture popin réactivation compte
  $("#reactivation-modal .Modal__Close").click(function (e) {
    $("#reactivation-modal").css({ opacity: 0, display: "none", visibility: "hidden" });
  });

  // Gestion de la réactivation d'email
  $(document).on("submit", "#reactivation-modal form", function (e) {
    e.preventDefault();
    var $that = $(this);
    $that.find(".Alert--error").hide();
    $.ajax({
      url: $(this).data("target"),
      method: "post",
      dataType: 'json',
      data: $(this).serialize() + "&lng=" + $that.data("lng")
    })
      .done(function (data) {
        if (!data.success) {
          $that.find(".Alert--error").html(data.msg).show();
        }
        else {
          if ($that.data("lng") == "fr") {
            $that.prev("h3").html("Merci !");
            $that.replaceWith('<div class="success"><p>Votre compte a bien été identifié, nous venons de vous faire parvenir un email pour le réactiver.</p></div>');
          }
          else {
            $that.prev("h3").html("Thank You!");
            $that.replaceWith('<div class="success"><p>Your account has been identified, we\'ve just sent you an email to reactivate it.</p></div>');
          }
        }
      });
  })
});

function isInViewport(el) {
  if (typeof el.get(0) === 'undefined') {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= ($(window).height() || $(document).height()) &&
    rect.right <= ($(window).width() || $(document).width())
  );
}

// Au scroll
const add_to_cart_buttons = $('.product-form__buttons');
const sticky_basket = $('#sticky_basket');

$(document).scroll(function () {

  if (add_to_cart_buttons.length === 0) {
    return;
  }

  const isVisible = isInViewport(add_to_cart_buttons);

  if (isVisible) {
    sticky_basket.slideUp(200);
  }
  else {
    sticky_basket.slideDown(200);
  }
});

// Fermeture du drawer quickshop
function close_quick_shop() {
  var $drawer = $("#shopify-section-quick_shop_drawer");
  $drawer.removeClass("opened_drawer");

  setTimeout(function () {
    $drawer.remove();
  }, 400);

  $("body").removeClass("noscroll");
  $(".blur").remove();
  $("#PopupModal-size-guide").remove();
}

function adjust_delivery_time() {
  var delivery_time = 72; // Nombre moyen d'heures pour être livré
  var now = new Date();
  var delivery_date = new Date();

  // Si on est le vendredi après 12h
  if (delivery_date.getDay() == 5 && delivery_date.getHours() >= 11) {
    delivery_date = delivery_date.addHours(24);
  }

  // Si on est un samedi ou dimanche, on repousse au lundi suivant
  if (now.getDay() == 6 || now.getDay() == 0) {
    var nb_weekend_day = delivery_date.getDay() == 6 ? 2 : 1;
    delivery_date = delivery_date.addHours(nb_weekend_day * 24);
  }

  delivery_date = delivery_date.addHours(delivery_time); // Jour de livraison supposé, hors jour chômés

  // Si on tombe sur une date de livraison un dimanche, on ajoute 24h.
  if (delivery_date.getDay() == 0) {
    delivery_date = delivery_date.addHours(24);
  }

  // Affichage
  var numero_jour_livraison = delivery_date.getDate();
  var nom_jour_livraison = delivery_date.toLocaleDateString("fr-FR", { weekday: 'long' });
  var nom_mois_livraison = delivery_date.toLocaleDateString("fr-FR", { month: 'long' });
  $(".estimated_delivery span").html(nom_jour_livraison + " " + numero_jour_livraison + " " + nom_mois_livraison);
  $(".estimated_delivery").fadeIn();
}

// Ajoute h Heures à une date existante
Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
}
